module.exports = __webpack_public_path__ + "img/logo-ecart.7431eb22.svg";